/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const Logo = () => (
  <h2 css={styles}>
    VIDYA <span>HOSTEL</span> 
  </h2>
); 

const styles = css`
  color: yellow;
  font-size: 30px;
  font-weight: 1100;
  line-height: 1.5;
  font-family: "Lucida Console";
  cursor: pointer;
  span {
    font-family: "Times New Roman";
    color: white;
  }
`;

export default Logo;
